import React from "react";
import Layout from "./src/components/Layout";
import "./src/styles/main.css"
import "@fontsource/open-sans" // Defaults to weight 400 with all styles included.

// Add this function to initialize the theme
export const onClientEntry = () => {
  // Check if window is defined (so this runs only on client)
  if (typeof window !== "undefined") {
    // Get the theme from localStorage or default to 'light'
    const theme = localStorage.getItem('theme') || 'light';
    
    // Apply the theme class to the body
    if (theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }
};

const transitionDelay = 350;

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay
    );
  }
  return false;
};
